import React from 'react'
import { Grid, Typography } from '@mui/material'

const NotFound = () => {
  return (
    <Grid container justifyContent="center" alignItems='center' className='container' direction='column'>
      <Grid item>
        <Typography variant="h6">Xin lỗi, trang này không tồn tại.</Typography>
      </Grid>

      <Grid item>
        <Typography variant="h6">Sorry, this page is not found.</Typography>
      </Grid>
    </Grid>
  );
}

export default NotFound
